package com.artvending.warden.screens.history

import androidx.compose.runtime.*
import androidx.compose.runtime.remember
import com.artvending.warden.Card
import com.artvending.warden.Column_
import com.artvending.warden.HistoryUnit
import com.artvending.warden.HistoryUnitMode
import com.artvending.warden.MdIcon
import com.artvending.warden.MdIconButton
import com.artvending.warden.MdLinearProgress
import com.artvending.warden.MdPrimaryTab
import com.artvending.warden.MdTabs
import com.artvending.warden.Row_
import com.artvending.warden.StackScope
import com.artvending.warden.TextButton
import com.artvending.warden.getDayOfWeekStr
import com.artvending.warden.getMonthFullNumber
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.minutesToTimeString
import com.artvending.warden.myOnClick
import com.artvending.warden.toColor
import com.artvending.warden.toMyString
import com.artvending.warden.today
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.div
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.gridColumn
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.transform
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Tr
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event


inline val org.w3c.dom.events.EventTarget.activeTabIndex: Int?
	get() = this.asDynamic().activeTabIndex as? Int


@OptIn(ExperimentalComposeWebApi::class)
@Composable
actual fun Any?.HistoryScreen(model: HistoryScreenModel) {
	if (settings.NEW_GUI) {
		this as StackScope
		
		HistoryScreen_(model)
		return
	}
	
	
	@Composable
	fun Month() {
		Row_({ style { gap(settings.smallSpace);flexGrow(1); padding(0.px, settings.space) } }) {
			Div({ classes(settings.headlineFontClass); style { flexGrow(1); marginLeft(settings.space) } }) {
				Text("${model.currentMonthStr} ${model.currentMonth / 12}")
			}
			
			MdIconButton({ myOnClick { model.currentMonth--; model.loadCurrentMonth(model.currentMonth) } }) {
				MdIcon {
					Img("left.svg", "<") { draggable(Draggable.False); }
				}
			}
			MdIconButton({ myOnClick { model.currentMonth++; model.loadCurrentMonth(model.currentMonth) } }) {
				MdIcon {
					Img("right.svg", ">") { draggable(Draggable.False); }
				}
			}
		}
	}
	
	
	@Composable
	fun DayView(units: List<HistoryUnit>, showDay: Boolean, stretch: Boolean) {
		if (units.isEmpty()) {
			Div({ style { alignSelf(if (stretch) AlignSelf.Stretch else AlignSelf.Start); padding(settings.smallSpace / 4); textAlign("center"); color(settings.opacityLightGray) } }) {
				Text(language.NO_DATA)
			}
		}
		else
			Div({ style { display(DisplayStyle.Grid); alignSelf(if (stretch) AlignSelf.Stretch else AlignSelf.Start); gridTemplateColumns(if (showDay) "[day-of-week] auto [day] auto " else "" + "[mode] auto [time] auto [space] 1fr") } }) {
				for ((i, unit) in units.withIndex()) {
					val date = unit.date
					val preDate = if (i > 0) units[i - 1].date else null
					val sameDate = preDate == date
					val otherWeek = preDate != null && ((date.dayOfMonth - preDate.dayOfMonth) >= 7 || date.dayOfWeek.ordinal < preDate.dayOfWeek.ordinal)
					
					if (showDay) {
						if (i > 0 && !sameDate)
							Div({ style { height(settings.space); gridColumn(1, 6) } })
						
						if (otherWeek)
							Div({ style { height(1.px); backgroundColor(settings.opacityLightGray); margin(0.px, -settings.space, settings.space, -settings.space); gridColumn(1, 6) } })
						
						if (!sameDate) {
							Div({ style { gridColumn(1, 2); padding(settings.smallSpace / 4, 0.px) } }) {
								Text("${date.getDayOfWeekStr()}. ")
							}
							Div({ style { gridColumn(2, 3); padding(settings.smallSpace / 4, 0.px) } }) {
								Text("${date.dayOfMonth}: ")
							}
						}
					}
					
					Div({ style { property("color", unit.mode.color.toColor()); gridColumn(3, 4); padding(settings.smallSpace / 4, 0.px) } }) {
						Text("${if (unit.mode == HistoryUnitMode.FIXED_WORKING_TIME) if (unit.date == today) unit.mode else language.IN_WORK2 else unit.mode}     ")
					}
					
					if (unit.fixedFrom != null || unit.fixedTo != null)
						Row_({ style { gridColumn(4, 5) } }) {
							Div({ style { borderRadius(100.px); padding(settings.smallSpace / 4, settings.smallSpace); if (unit.getLate(model.units) > 0) backgroundColor(rgba(255, 0, 0, 0.15)) } }) {
								if (unit.mode == HistoryUnitMode.FIXED_WORKING_TIME && unit.fixedFrom == null)
									Span({ style { property("visibility", "hidden") } }) {
										Text("00:00")
									}
								else
									Text(minutesToTimeString(unit.fixedFrom, true))
							}
							Div({ style { padding(settings.smallSpace / 4, settings.smallSpace / 2) } }) {
								Text("-")
							}
							Div({ style { borderRadius(100.px); padding(settings.smallSpace / 4, settings.smallSpace); if (unit.getEarlyEnd(model.units) > 0) backgroundColor(rgba(255, 0, 0, 0.15)) } }) {
								if (unit.mode == HistoryUnitMode.FIXED_WORKING_TIME && unit.fixedTo == null)
									Span({ style { property("visibility", "hidden") } }) {
										Text("00:00")
									}
								else
									Text(minutesToTimeString(unit.fixedTo, true))
							}
						}
				}
			}
	}
	
	
	@Composable
	fun ListView() {
		Card {
			if (model.progress)
				Div({ style { alignSelf(AlignSelf.Stretch); padding(settings.smallSpace / 4); textAlign("center"); color(settings.opacityGray) } }) {
					Text(language.LOADING_DATA)
				}
			else
				DayView(model.units, true, true)
		}
	}
	
	var tabsRef: HTMLElement? by remember { mutableStateOf<HTMLElement?>(null) }
	
	
	@Composable
	fun Calendar() {
		val today = today
		val firstDayOfMonth = LocalDate(model.currentMonth / 12, (model.currentMonth % 12) + 1, 1)
		val firstDayOfMonthDayOfWeek = firstDayOfMonth.dayOfWeek.ordinal
		var date = firstDayOfMonth.plus(-firstDayOfMonthDayOfWeek, DateTimeUnit.DAY)
		
		
		Card {
			Table({ style { margin((-2).px); property("border-spacing", "2px") } }) {
				Tr {
					for (i in 0..6){
						Td({
							style {
								padding(settings.smallSpace, 0.px)
								textAlign("center")
								
								if (i == 5 || i == 6)
									color(settings.opacityGray)
							}
						}) {
							Text(getDayOfWeekStr(i))
						}
					}
				}
				
				for (i in 0..5) {
					Tr {
						for (j in 0..6) {
							Td {
								if (date.getMonthFullNumber() == model.currentMonth) {
									val date = LocalDate(date.year, date.month, date.dayOfMonth)
									
									TextButton(
										{ model.selectDate(date) },
										{
											style {
												property("aspect-ratio", "1 / 1")
												padding(settings.smallSpace, 0.px)
												minWidth(0.px)
												minHeight(0.px)
												if (date == today) fontWeight("bold")
												position(Position.Relative)
											}
										}) {
										Column_({ style { position(Position.Absolute); top(0.px); right(0.px); bottom(0.px); left(0.px); gap(2.px) } }) {
											for (unit in model.units.filter { it.date == date }) {
												Div({ style { flexGrow(1); property("background-color", unit.mode.color.toColor()); opacity(0.15) } })
											}
										}
										
										if (date == today)
											Column_({
												style {
													borderRadius(100.px)
													property("aspect-ratio", "1 / 1")
													position(Position.Absolute)
													top(0.px)
													bottom(0.px)
													left(50.percent)
													transform { translate((-50).percent) }
													border(1.px, LineStyle.Solid, Color.royalblue)
												}
											}) {
											}
										
										if (date == model.selectedDate)
											Column_({
												style {
													borderRadius(100.px)
													property("aspect-ratio", "1 / 1")
													position(Position.Absolute)
													top(0.px)
													bottom(0.px)
													left(50.percent)
													transform { translate((-50).percent) }
													backgroundColor(Color.royalblue)
												}
											}) {
											}
										Div({
											style {
												top(50.percent); transform { translate(0.percent, (-50).percent) };
												position(Position.Absolute);
												right(0.px);
												bottom(0.px);
												left(0.px);
												fontWeight(400)
												color(
													if (j == 5 || j == 6 || date.getMonthFullNumber() != model.currentMonth){
														//log(date.toMyString())
														settings.opacityGray
													}
													else
														if (model.units.any { it.date == date && (it.getLate(model.units) > 0 || it.getEarlyEnd(model.units) > 0) }) {
															if (date == model.selectedDate)
																Color.pink
															else
																Color.red
														}
														else
															if (date == model.selectedDate)
																Color.white
															else
																Color.black
												
												)
											}
										}) {
											Text(date.dayOfMonth.toString())
										}
										Text(" ")
									}
								}
							}
							
							date = date.plus(1, DateTimeUnit.DAY)
						}
					}
				}
			}
		}
		
		if (model.selectedDate?.getMonthFullNumber() == model.currentMonth)
			Card {
				Div({ classes(settings.titleFontClass) }) {
					Text(model.selectedDate?.toMyString() ?: "")
				}
				DayView(model.selectedDateUnits, false, false)
			}
	}
	
	
	Column_({ style { gap(settings.space); marginTop(-settings.space) } }) {
		Column_({
			style {
				position(Position.Sticky);
				overflow("hidden")
				top(-settings.space);
				property("background-color", "#eeeeee");
				property("z-index", "1")
				margin(0.px, -settings.space)
				gap(settings.space + settings.smallSpace)
			}
		}) {
			MdTabs({
				ref { tabsRef = it; onDispose { tabsRef = null } }
				style { margin(0.px, -settings.space) }
			}) {
				MdPrimaryTab(true) {
					Text(language.CALENDAR)
				}
				MdPrimaryTab {
					Text(language.LIST)
				}
			}
			Month()
		}
		MdLinearProgress {
			style {
				if (!model.progress) property("visibility", "hidden")
				margin(-settings.smallSpace, -settings.space)
			}
		}
		
		if (model.isCalendarMode)
			Calendar()
		else
			ListView()
		
	}
	
	LaunchedEffect(Unit) {
		tabsRef?.let { element ->
			element.addEventListener("change", { event: Event ->
				model.isCalendarMode = event.target?.activeTabIndex == 0
			})
		}
	}
}